import { render, staticRenderFns } from "./IconInvoice.vue?vue&type=template&id=2cd909d3&"
import script from "./IconInvoice.vue?vue&type=script&lang=js&"
export * from "./IconInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports